import { HStack, Table, Tbody, Td, Thead } from '@talos/kyoko';
import type { CSSProperties } from 'react';
import styled from 'styled-components';

export const MarketDisplayName = styled(Td)`
  min-width: 80px;
`;

export const StatusTableCell = styled(Td)`
  position: relative;
`;

export const StatusTableCellLinks = styled(HStack)``;
StatusTableCellLinks.defaultProps = {
  background: 'gray.040',
  position: 'absolute',
  px: 'spacing4',
  top: 0,
  right: 'spacing16',
  bottom: 0,
  gap: 'spacing4',
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
};

const STATUS_TABLE_ROW_HEIGHT = 32;
interface WrapperProps {
  width?: CSSProperties['width'];
  compact?: boolean;
}
export const Wrapper = styled(Table)<WrapperProps>`
  ${({ theme, width, compact = false }) => `
  ${(width && `width: ${width};`) || null}

  && {
    font-size: ${theme.fontSizeDefault}rem;
    font-weight: ${theme.fontWeightRegular};
  }

  ${Thead} th,
  ${Tbody} td {
    padding: ${theme.spacing4}px ${compact ? 0 : ''};
    white-space: nowrap;
    ${!compact && `height: ${STATUS_TABLE_ROW_HEIGHT}px;`}
  }
  ${Tbody} ${MarketDisplayName} {
    padding: ${theme.spacing4}px;
    white-space: nowrap;
  }

  ${Thead} th:first-child,
  ${Tbody} td:first-child {
    padding-left: ${compact ? theme.spacing4 : theme.spacing12}px;
    text-align: left;
    color: ${theme.colorTextDefault};
  }

  ${Tbody} tr:hover {
    transition: background 0.2s ease-in-out;
    ${!compact && `background: ${theme.colors.gray['040']};`}
    ${StatusTableCellLinks} {
      opacity: 1;
    }
  }
`}
`;
